module.exports = __webpack_public_path__ + "static/media/cellere-logo.62c8d964.png";